export const TaxFormKeys = {
  settings: 'taxFormSettings',
  ustva: 'ustva',
  euer: 'euer',
  taxFormHistoryList: 'taxFormHistoryList',
}

export type TaxKey = 'ustva' | 'euer'

// magic-key to identify the period selection form for scrolling to it after toc selection
export const PeriodSelectionComponentId = 'fea1d5d3-5f8e-4fa2-80bb-be062aa0cffe'

export const TRANSFER_OBJECT_TYPE = Object.freeze({ EXPORT_XML: 'EXPORT_XML', REPORT_ONLY: 'REPORT_ONLY', EXPORT_XML_AND_REPORT: 'EXPORT_XML_AND_REPORT' })
export const PRIMARY_ACTIONS = Object.freeze({ XML: { key: 'xml', closeForm: true }, ONLINE: { key: 'online', closeForm: true } })
